export const TYPE_DEFAULT = 0;
export const TYPE_SEVERAL = 1;
export const TYPE_SEQUENCE = 2;
export const TYPE_MATCH = 3;
export const TYPE_OPEN_SHORT_TYPE_1 = 4;
export const TYPE_OPEN_SHORT_STRUCTURED = 5;
export const TYPE_OPEN = 6;